/* eslint-disable sort-keys-fix/sort-keys-fix */
import { useRetailerLocation } from '@lib/core/retailers/hooks/useRetailerLocation';
import { useApp } from '@lib/core/service/hooks';
import { COLOR_BLEND_STEPS, DEFAULT_PRODUCT_CATEGORY_COLORS } from '@lib/tools/shared/helpers/consts';
import { TColorShades } from '@lib/tools/shared/helpers/interfaces';

export const createShadeVars = (prefix: string): TColorShades =>
  Object.fromEntries(Object.keys(COLOR_BLEND_STEPS).map(shade => [shade, `var(${prefix}${shade})`])) as TColorShades;

const blendHexWithRgb = (color: string, targetColor: number[], amount: number): string => {
  const [r, g, b] = color.match(/\w\w/g).map(c => parseInt(c, 16));

  // Mixing the color with targetColor
  const mix = (channel: number, target: number) => Math.round(channel + (target - channel) * amount);

  return `#${mix(r, targetColor[0]).toString(16).padStart(2, '0')}${mix(g, targetColor[1])
    .toString(16)
    .padStart(2, '0')}${mix(b, targetColor[2]).toString(16).padStart(2, '0')}`.toUpperCase();
};

export const useRetailerColors = () => {
  const { retailerLocationCustomStyle } = useRetailerLocation();
  const { productCategory } = useApp();

  const retailerPrimaryColor = retailerLocationCustomStyle?.primaryColor || '#4091A0';
  const retailerSecondaryColor = retailerLocationCustomStyle?.secondaryColor || '#E0E2DA';
  const retailerProductColor =
    DEFAULT_PRODUCT_CATEGORY_COLORS[productCategory]?.['500'] ?? DEFAULT_PRODUCT_CATEGORY_COLORS.default['500'];

  const generateColorShades = (baseColor: string) => {
    return Object.keys(COLOR_BLEND_STEPS).reduce((acc, key) => {
      const [targetColor, amount] = COLOR_BLEND_STEPS[key];
      acc[key] = blendHexWithRgb(baseColor, targetColor, amount);
      return acc;
    }, {} as TColorShades);
  };

  return {
    retailerPrimaryColor: generateColorShades(retailerPrimaryColor),
    retailerSecondaryColor: generateColorShades(retailerSecondaryColor),
    retailerProductColor: generateColorShades(retailerProductColor),
  };
};
